<template>
   <div class="shangquanfenleiPage">
      <XR-head titleText="众创商城" :rightShow="false" ref="headObj"></XR-head>
      <mu-appbar class="XR-search-head">
        <mu-flat-button :label="addressCache" @click="selectArea"  class="demo-flat-button" labelPosition="before" icon=":fa fa-angle-down" secondary  slot="left"/>             
        <div slot="default" class="search-ctrl">
          <mu-icon value=" " class="fa fa-xisearch" color="#999" slot="right"/> 
          <input class="input-ctrl" placeholder="请输入关键词" />          
        </div>
        <mu-icon value=" " class="fa fa-fenlei1" color="#999" slot="right"/>  
      </mu-appbar>
      <mu-list>
          <mu-list-item >
              <mu-flat-button label="分类" class="demo-flat-button" labelPosition="before" icon=":fa fa-daosanjiao" secondary  slot="left"/>
              <mu-flat-button label="全程" class="demo-flat-button" labelPosition="before" icon=":fa fa-daosanjiao" secondary  slot="left"/>
              <mu-flat-button label="排序" class="demo-flat-button" labelPosition="before" icon=":fa fa-daosanjiao" secondary  slot="left"/>             
          </mu-list-item>
          <mu-list-item  class="proList">
              <div class="product-item">
                <router-link to="">
                  <img src=" ../static/shangquan/1.png" class="pro-img"> 
                  <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                    <div class="active">
                      <p class="fontIcon wua">[武汉火车站]单人自助午餐提供给您免费WiFi</p>
                    </div> 
                      <div class="saleinfo">
                        <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                        <p class="saleCount"><span>4.1分</span>20191</p>
                      </div>
                    </div>
                  </router-link>
                </div>
          </mu-list-item>
          <mu-list-item  class="proList">
              <div class="product-item">
                <router-link to="">
                  <img src=" ../static/shangquan/2.png" class="pro-img"> 
                  <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                    <div class="active">
                      <p class="fontIcon wua">[武汉火车站]单人自助午餐提供给您免费WiFi</p>
                    </div> 
                      <div class="saleinfo">
                        <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                        <p class="saleCount"><span>4.1分</span>20191</p>
                      </div>
                    </div>
                  </router-link>
                </div>
          </mu-list-item>
      </mu-list>
      <mu-list class="love">
          <mu-list-item  title="猜你喜欢" class="proList1">
            <mu-icon slot="left" value=":fa fa-xingxing " color="red"/>
            <mu-flat-button label="全部团购" class="demo-flat-button" labelPosition="before" icon=":fa fa-angle-right" secondary  slot="right"/>    
          </mu-list-item>
          <mu-list-item  class="proList">
              <div class="product-item">
                <router-link to="">
                  <img src=" ../static/shangquan/1.png" class="pro-img"> 
                  <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                    <div class="active">
                      <p class="fontIcon wua">[武汉火车站]单人自助午餐提供给您免费WiFi</p>
                    </div> 
                      <div class="saleinfo">
                        <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                        <p class="saleCount"><span>4.1分</span>20191</p>
                      </div>
                    </div>
                  </router-link>
                </div>
          </mu-list-item>
          <mu-list-item  class="proList">
              <div class="product-item">
                <router-link to="">
                  <img src=" ../static/shangquan/2.png" class="pro-img"> 
                  <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                    <div class="active">
                      <p class="fontIcon wua">[武汉火车站]单人自助午餐提供给您免费WiFi</p>
                    </div> 
                      <div class="saleinfo">
                        <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                        <p class="saleCount"><span>4.1分</span>20191</p>
                      </div>
                    </div>
                  </router-link>
                </div>
          </mu-list-item>
          <mu-list-item  class="proList">
              <div class="product-item">
                <router-link to="">
                  <img src=" ../static/shangquan/2.png" class="pro-img"> 
                  <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                    <div class="active">
                      <p class="fontIcon wua">[武汉火车站]单人自助午餐提供给您免费WiFi</p>
                    </div> 
                      <div class="saleinfo">
                        <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                        <p class="saleCount"><span>4.1分</span>20191</p>
                      </div>
                    </div>
                  </router-link>
                </div>
          </mu-list-item>
      </mu-list>
   </div>
</template>
<script>
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-135),
      addressCache :''
    }
  },
  mounted() {
     this.getSiteInfo()
     
    var countyCache = window.localStorage.ProductDetailDeliveryAreaCache
    if(countyCache){
      this.addressCache = countyCache
    }else{
      var cityCache = window.localStorage.ProductDetailDeliveryCityCache
      if(cityCache){
        this.addressCache = cityCache
      }
    }
    if(!this.addressCache){
      this.dialog = true
    }else{
      if(this.addressCache.length>3){
        this.addressCache = this.addressCache.substr(0,3)+"..."
      }
    }
  },
  methods: {
    selectArea(){
      this.$router.push('/address')
    },
    goAddress(){
      this.$router.push("/address")
    },
     getSiteInfo: function() {
      const ths = this;
      this.$post("/Shop/SiteConfigServer/GetSiteConfig")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.siteInfo = res.Data;
          siteconfig.addSiteconfig(res.Data)
          ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },  
    
    close(){
      window.localStorage.ProductDetailDeliveryProvinceCache = '湖北省'
      window.localStorage.ProductDetailDeliveryCityCache = '武汉市'
      window.localStorage.ProductDetailDeliveryCityCodeCache = '420100'
      window.localStorage.ProductDetailDeliveryAreaCache = '武昌区'
      this.addressCache = window.localStorage.ProductDetailDeliveryAreaCache
    }
    
  },
  computed: {
    
  }
};
</script>
<style>
body .shangquanfenleiPage .XR-search-head{
  height: 48px;
  text-align: center;
  background: #fff;
}
.shangquanfenleiPage .XR-search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.shangquanfenleiPage .XR-search-head .mu-appbar-title {
  font-size: 16px;
  padding: 0 16px 0 0;
}
.shangquanfenleiPage .XR-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.shangquanfenleiPage .XR-search-head .title .title-text {
  margin: 0;
  line-height: 48px;
}

.shangquanfenleiPage .XR-search-head .search-ctrl{
  width: 95%;
  height: 25px;
  line-height: 25px;
  border-radius: 25px;
  padding-right: 10px;
  color:#ccc;
  background: #f5f5f5;
  overflow: hidden;
}
.shangquanfenleiPage .XR-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 25px;
  font-size: 12px;
  width: 80%;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  color:#999;
}
.shangquanfenleiPage .XR-search-head .search-ctrl .icon-ctrl{
  width: 10%;
  float: right;
  line-height: 28px;
  text-align: right;
  color:#ccc;
}
.shangquanfenleiPage .left .mu-flat-button-label{
  color: #999;
  padding: 0;
}
.shangquanfenleiPage .XR-search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.shangquanfenleiPage .XR-search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
.shangquanfenleiPage .mu-appbar-title  .fa-xisearch{
    width: 20%;
    padding-left: 5%;
    padding-top: 2.5%;
    float: left;
    font-size: 14px;
}
.shangquanfenleiPage .mu-flat-button.label-before .fa-angle-down{
  font-size: 14px;
  width: 20px;
  color: #999;
}
.shangquanfenleiPage .mu-list{
  background: #fff;
  padding-top: 0;
  padding-bottom: 0;
}
.shangquanfenleiPage .mu-list .mu-item-left{
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
}
.shangquanfenleiPage .mu-list .mu-flat-button.label-before .mu-flat-button-label{
  padding-right: 0px;
  color: black;
}
.shangquanfenleiPage .mu-list .mu-flat-button.label-before .fa-daosanjiao{
  font-size: 14px;
  width: 20px;
  color: #999;
}

.shangquanfenleiPage  .mu-item-left{
  width: 100%;
  left: 0;
}
.shangquanfenleiPage .love .mu-item-left{
  left: 16px;
}
.shangquanfenleiPage .love .proList1 .mu-item-title{
  font-size: 15px;
}
.shangquanfenleiPage .mu-list .mu-item-left .mu-flat-button{
  flex: 1;
  border-right: 1px solid #f5f5f5;
  padding-right: 0px;
}
.shangquanfenleiPage .proList .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px;
  height: 120px;
}
.shangquanfenleiPage .proList .mu-item{
  padding: 0px;
}
.shangquanfenleiPage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquanfenleiPage .product-item a{  
  color:black;
}
.shangquanfenleiPage .product-item .pro-img{
  width: 105px;
  float: left;
  background: white;
  max-height: 105px;
}
.shangquanfenleiPage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
}
.shangquanfenleiPage .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 16px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shangquanfenleiPage .product-item .product-info .active{
  overflow: hidden;
  height: 50px;
}
.shangquanfenleiPage .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  color:#999;
  border-radius: 2px;
  height: 14px;
  line-height: 14px;
  margin: 6px 1px;
  height: 50px;
  line-height: 20px;
}
.shangquanfenleiPage .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
  margin-top: 15px;
}
.shangquanfenleiPage .product-item  .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  float: left;
  font-size: 16px;
  color:Red;
  padding-right: 10px;
}
.shangquanfenleiPage .product-item  .product-info .saleinfo .price .fa{
  font-size: 14px;
  margin-right: 5px;
}
.shangquanfenleiPage .product-item  .product-info .saleinfo .saleCount{
  float: right;
  color:#ccc;
  font-size: 12px;
}
.shangquanfenleiPage .product-item  .product-info .saleinfo .saleCount span{
      font-size: 14px;
      color: red;
}
.shangquanfenleiPage .shop-list .shop-item .shop-product-list{
  overflow: hidden;
}
.shangquanfenleiPage .shop-list .shop-item .shop-product-list .shop-product-item{
  width:33.33%;
  float: left;
}
.shangquanfenleiPage .shop-list .shop-item .shop-product-list .shop-product-item .pro-img{
  width: 100%;
}
.shangquanfenleiPage .shop-list .shop-item .shop-product-list .shop-product-item .pro-price{
  
}

.shangquanfenleiPage .shop-list .entrance{
  margin-top: 5%;
  height: 100px;
  padding: 0 3%;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #dedede;
}
.shangquanfenleiPage .shop-list .enceimg{
  float: left;
  width: 20%;
  height: 100%;
   display: flex;
  align-items: center;  
  justify-content: center;
}
.shangquanfenleiPage .shop-list .enceimg img{
  width: 100%;
}
.shangquanfenleiPage .shop-list .store{
  width: 60%;
  height: 100%;
  padding: 3% 1%;
  float: left;
}
.shangquanfenleiPage .shop-list .jian{
  width: 20%;
  height: 100%;
  text-align: center;
  padding: 5% 0;
  float: left;
}
.shangquanfenleiPage .shop-list .jian img{
  width: 15px;
  height: 10px;

}
.shangquanfenleiPage .shop-list .pro-list{
  overflow: hidden;
  width: 100%; 
  padding: 3% 3% 0 3%;
  background: #fff;
}
.shangquanfenleiPage .shop-list .pro-list .item-left{
  float: left;
  width: 32%;
  text-align: center;
  background-size: cover;
  position: relative;
}
.shangquanfenleiPage .shop-list .pro-list .item-left img{
  width: 90%;
}
.shangquanfenleiPage .shop-list .pro-list .item-left span{
  background: #f19500;
  color: white;
  padding:  0 2%;
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  bottom: 3px;
  left: 30px;
}
.shangquanfenleiPage .mu-list .proList{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanfenleiPage .mu-list .proList:last-child{
  border: 0;
}
.shangquanfenleiPage .love ,.proList:last-child{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanfenleiPage .love .mu-item.show-left{
  padding-left: 45px;
}
.shangquanfenleiPage .mu-list .fa-xingxing{
  font-size: 20px;
}
.shangquanfenleiPage .love{
  margin-top: 10px;
}
.shangquanfenleiPage .proList1 .demo-flat-button .mu-flat-button-wrapper .mu-flat-button-label{
  font-size: 14px;
  padding: 0px;
  color:#ccc;
}
.shangquanfenleiPage .proList1 .demo-flat-button .mu-flat-button-wrapper .fa-angle-right{
  font-size: 16px;
  color: #ccc;
}
.shangquanfenleiPage .proList .demo-flat-button .mu-flat-button-wrapper{
  padding-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shangquan/fenlei.vue